import React from 'react'
import styled from 'styled-components'
import { MyTheme } from 'Components/common/Theme'
import { numberWithComma } from 'helpers/format'
import { Col, Dropdown, Image, Row, Space } from 'antd'
import { appConfig } from 'config'
import { TableListPage } from 'Components/common/Table'
import { ClockCircleOutlined, DownloadOutlined, PrinterOutlined } from '@ant-design/icons'
import { ImageFallback } from 'helpers/constanst'
import { PrimaryButton } from 'Components/button'
import { PickUpProduct, PurchaseProduct } from 'Store/purchase/types'
import { StatusTag } from 'Components/utilities'
import { MenuPrints } from 'Components/form'
import ProductUomMultiplier from 'Pages/Product/components/ProductUomMultiplier'

type Props = {
  products: PurchaseProduct[]
  productsPickup?: PickUpProduct[]
  onClickPickUp: (products: PickUpProduct) => void
  onClickPickUpAll: (products: PickUpProduct[]) => void
  purchasePdfRef?: any
  purchaseLitePdfRef?: any
  purchasing_no?: string
}

const ProductsTable: React.FunctionComponent<Props> = props => {
  const {
    products,
    onClickPickUp = () => {},
    purchasePdfRef,
    purchaseLitePdfRef,
    purchasing_no = '',
    productsPickup = [],
    onClickPickUpAll = () => {},
  } = props

  const renderInfo = (val: any) => {
    return <RowTile>{val}</RowTile>
  }

  const renderImage = (photo: any) => (
    <ThumbImage src={appConfig.assetCdnEndpoint + photo} fallback={ImageFallback} />
  )

  const renderProductName = (item: string, record: PurchaseProduct) => {
    const isSameTitle = record.product_name == record.product_option_name
    return (
      <>
        <RowTile>{record.product_name}</RowTile>
        {!isSameTitle && <ProductDesc>{record.product_option_name}</ProductDesc>}
      </>
    )
  }

  const isSelected = (purchaingID: number) => {
    const data = productsPickup.find(item => item.purchasing_item_id === purchaingID)
    return data ? true : false
  }

  const filterProduct = (products: PurchaseProduct[]) => {
    const newProduct = [] as PurchaseProduct[]
    products.forEach(item => {
      if (!isSelected(item.id || 0)) {
        newProduct.push(item)
      }
    })
    return newProduct
  }

  const formatPickupData = (product: PurchaseProduct) => {
    const remain = (product?.amount || 0) - (product?.received_amount || 0)
    return {
      purchasing_item_id: product.id || 0,
      received_amout: remain,
      hidden_cost: 0,
      product_id: product.product_id,
      product_option_id: product?.product_option_id,
      purchase_info: product,
      percent: product?.product_online_percentage || 0,
    } as PickUpProduct
  }

  const formatPickupAllProduct = () => {
    const orgProduct = products
    const pickups = [] as PickUpProduct[]
    orgProduct &&
      orgProduct.forEach(item => {
        if (item.amount > (item?.received_amount || 0)) {
          pickups.push(formatPickupData(item))
        }
      })
    return pickups
  }

  const renderActionButton = (text: string, record: PurchaseProduct) => {
    if (record.amount === record?.received_amount) {
      return (
        <Center>
          <Space size="large" align="end">
            <StatusTag text={'รับครบแล้ว'} color={'green'} />
          </Space>
        </Center>
      )
    }

    return (
      <Center>
        <Space size="large" align="end">
          <PrimaryButton
            text="รับเข้า"
            btnType="Primary"
            size="small"
            onClick={() => onClickPickUp(formatPickupData(record))}
            icon={<DownloadOutlined />}
          />
        </Space>
      </Center>
    )
  }

  const renderQuantity = (item: string, record: PurchaseProduct) => {
    const remain = record.amount - (record?.received_amount || 0)
    if (remain <= 0) {
      return 0
    }
    return (
      <>
        <RemainProduct>{numberWithComma(remain)}</RemainProduct>
      </>
    )
  }

  const renderPrice = (item: string, record: PurchaseProduct) => {
    return <TextRight>{numberWithComma(record.price_per_unit, true)}</TextRight>
  }

  const renderProductUom = (uom: string, record: PurchaseProduct) => {
    const uoms = record?.uoms || []
    const master = uoms?.find(item => item.is_master)
    const current = uoms?.find(item => item.id === record.product_uom_id)
    return (
      <span>
        <ProductUomMultiplier masterUom={master} quantity={record.amount || 0} currentUom={current} />
      </span>
    )
  }

  const columns = [
    {
      title: <ColTile>ลำดับ</ColTile>,
      dataIndex: 'no',
      key: 'no',
      render: (value: any, record: any, index: number) => {
        return renderInfo(index + 1)
      },
      width: '50px',
    },
    {
      title: <ColTile>รูปภาพ</ColTile>,
      dataIndex: 'product_photo',
      key: 'product_photo',
      render: renderImage,
      width: '100px',
    },
    {
      title: <ColTile>รหัสสินค้า</ColTile>,
      dataIndex: 'product_sku',
      key: 'product_sku',
      width: '100px',
      render: (value: any) => renderInfo(value || '-'),
    },
    {
      title: <ColTile>ยี่ห้อ</ColTile>,
      dataIndex: 'product_manufacture',
      key: 'product_manufacture',
      render: (value: any) => renderInfo(value || '-'),
      width: '100px',
    },
    {
      title: <ColTile>รายการ</ColTile>,
      dataIndex: 'product_name',
      key: 'product_name',
      render: renderProductName,
      width: '200px',
    },
    {
      title: <ColTile>จำนวนที่สั่งซื้อ</ColTile>,
      dataIndex: 'amount',
      key: 'amount',
      width: '100px',
    },
    {
      title: <ColTile>หน่วย</ColTile>,
      dataIndex: 'product_uom',
      key: 'product_uom',
      width: '100px',
      render: renderProductUom,
    },
    {
      title: <ColTile>ค้างรับ</ColTile>,
      dataIndex: 'amount',
      key: 'amount',
      width: '100px',
      render: renderQuantity,
    },
    // {
    //   title: <ColTile>ค้างรับ</ColTile>,
    //   dataIndex: 'amount',
    //   key: 'amount',
    //   width: '100px',
    //   render: renderQuantity,
    // },
    {
      title: (
        <ColTile>
          <TextRight>ราคาต่อหน่วย</TextRight>
        </ColTile>
      ),
      dataIndex: 'price_per_unit',
      key: 'price_per_unit',
      width: '100px',
      render: renderPrice,
    },
    {
      title: '',
      key: 'action',
      render: renderActionButton,
      width: '100px',
    },
  ]

  const renderHeader = () => {
    return (
      <Row justify="space-between" gutter={[32, 32]} align="middle">
        <Col>
          <BoxTitle>
            <ClockCircleOutlined /> รายการรอรับสินค้าเข้าคลัง
          </BoxTitle>
        </Col>
        <Col>
          <Space>
            {filterProduct(products).length > 0 && (
              <PrimaryButton
                btnType="Primary"
                text="รับเข้าคลังทั้งหมด"
                icon={<DownloadOutlined />}
                onClick={() => {
                  onClickPickUpAll(formatPickupAllProduct())
                }}
                size="middle"
                className="ttr-pickup-all"
              />
            )}
            <Dropdown
              key="more"
              overlay={
                <MenuPrints
                  nomalPrintRef={purchasePdfRef}
                  litePrintRef={purchaseLitePdfRef}
                  title={`ใบสั่งซื้อ-${purchasing_no}`}
                />
              }
              trigger={['click', 'hover']}
            >
              <PrimaryButton
                btnType="Approve"
                text="ใบสั่งซื้อ"
                icon={<PrinterOutlined />}
                onClick={() => {}}
                size="middle"
              />
            </Dropdown>
          </Space>
        </Col>
      </Row>
    )
  }

  return (
    <BoxWrapper>
      <Row gutter={[16, 16]}>
        <Col span={24}>
          {renderHeader()}
          <TableListPage
            rowKey="product_option_id"
            tableName="product-purchase"
            columns={columns}
            datas={filterProduct(products)}
            size={'small'}
            scrollX={800}
          />
        </Col>
      </Row>
    </BoxWrapper>
  )
}

const BoxTitle = styled.div`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body3};
  font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.primary};
`

const BoxWrapper = styled.div`
  width: 100%;
  border-radius: 10px;
  padding: 15px 10px;
  //border: 1px solid ${(props: { theme: MyTheme }): string => props.theme.colors.whitebg};
  border: 1px solid #f0f0f0;
  margin-bottom: 10px;
  background-color:  ${(props: { theme: MyTheme }): string => props.theme.colors.white};
`

const ThumbImage = styled(Image)`
  border-radius: 5px;
  width: 70px;
  height: 70px;
  object-fit: cover;
`

const ColTile = styled.span`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
`

const RowTile = styled.div`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
`

const ProductDesc = styled(RowTile)`
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.grey};
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body5};
`

const TextRight = styled.div`
  text-align: right;
`

const RemainProduct = styled.span`
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.error};
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
`

const Center = styled.div`
  text-align: center;
`

export default ProductsTable
